import { deliverPdfBlob } from "./deliverPdfBlob";

let fontsInitialized = false;

export async function getPdfMake() {
  const [{ default: pdfMake }, { default: robotoFontContainer }] = await Promise.all([
    import("pdfmake/build/pdfmake"),
    import("pdfmake/build/fonts/Roboto"),
  ]);

  if (!fontsInitialized) {
    pdfMake.addFontContainer(robotoFontContainer);
    fontsInitialized = true;
  }

  return pdfMake;
}

export async function exportReportPdf(docDefinition, filename, title) {
  const pdfMake = await getPdfMake();
  const pdfDoc = pdfMake.createPdf(docDefinition);
  const blob = await pdfDoc.getBlob();

  await deliverPdfBlob(blob, filename, { title });
}
